import React from 'react';
import { useRouter } from 'next/router';

import { PinnedFilters } from 'components/common/PinnedFilters/PinnedFilters';
import { useAssignees } from '@hooks';
import { useSelector } from 'react-redux';
import { selectGreenCardPinnedFilters } from '@store';

const GreenCardFilter = () => {
  const router = useRouter();
  const { assigneesWithNone } = useAssignees();
  const pinnedFilters = useSelector(selectGreenCardPinnedFilters);

  const handleChangeFilter = (val, filterName) => {
    if (val?.value) {
      router.query.page = 1;
      router.query[filterName] = val?.value;
    } else {
      delete router.query[filterName];
    }
    router.push(router);
  };

  const FILTERS_CONFIG = [
    {
      key: 'assignee',
      label: 'Assignee',
      type: 'filterAutocomplete',
      width: '250px',
      isMulti: false,
      options: assigneesWithNone || [],
      value: router.query?.assignee || '',
    },
  ];
  return (
    <PinnedFilters
      pinnedFilters={pinnedFilters}
      filtersConfig={FILTERS_CONFIG}
      handleChangeSingleFilter={handleChangeFilter}
    />
  );
};

const memoizedGreenCardFilter = React.memo(GreenCardFilter);
export { memoizedGreenCardFilter as GreenCardFilter };

export default memoizedGreenCardFilter;
